/* Hover video (snippets/hover-video.liquid): a photograph that plays its
   product's video while the pointer is over it -- the video fades in over the
   photograph once it is actually playing, and pauses where it was on the way
   out. Mouse and trackpad only; touch screens keep the photograph.

   Experiment (settings.couture_autoplay_mobile, data-autoplay): on a phone a
   collection grid's cover plays its video by itself while it is on screen --
   from the moment a fifth of it has scrolled into view until less than a fifth
   is left -- and goes back to the photograph as it leaves. The next one starts
   loading half a screen before it arrives. */
(function () {
  if (window.__hoverVideo) return;
  window.__hoverVideo = true;

  function load(video) {
    if (video.getAttribute('src')) return;
    video.src = video.dataset.src;
    video.addEventListener('error', function () {
      if (video.dataset.fallback && video.getAttribute('src') !== video.dataset.fallback) video.src = video.dataset.fallback;
    }, { once: true });
    video.addEventListener('playing', function () { video.classList.add('is-ready'); });
  }

  function play(video) {
    load(video);
    video.classList.add('is-on');
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  function stop(video) {
    video.classList.remove('is-on');
    video.pause();
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var videoFor = function (target) {
      var host = target.closest && target.closest('[data-hover-video-host]');
      return host ? host.querySelector('video.hover-video') : null;
    };

    document.addEventListener('mouseover', function (event) {
      var video = videoFor(event.target);
      if (!video || video.contains(event.relatedTarget) || (event.relatedTarget && video.parentElement.contains(event.relatedTarget))) return;
      play(video);
    });

    document.addEventListener('mouseout', function (event) {
      var video = videoFor(event.target);
      if (!video) return;
      var host = video.closest('[data-hover-video-host]');
      if (event.relatedTarget && host.contains(event.relatedTarget)) return;
      stop(video);
    });
    return;
  }

  // Phones: play what is on screen.
  if (!window.IntersectionObserver || !window.matchMedia('(max-width: 749px)').matches) return;
  var SELECTOR = '.product-grid video.hover-video[data-autoplay]';
  var VISIBLE = 0.2;

  var onScreen = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE) play(entry.target);
      else stop(entry.target);
    });
  }, { threshold: [0, VISIBLE] });

  var nearby = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.preload = 'auto';
      load(entry.target);
      nearby.unobserve(entry.target);
    });
  }, { rootMargin: '50% 0px' });

  function watch() {
    document.querySelectorAll(SELECTOR).forEach(function (video) {
      if (video._autoplay) return;
      video._autoplay = true;
      onScreen.observe(video);
      nearby.observe(video);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // Filtering and sorting replace the grid's contents.
  var grid = document.getElementById('ProductGridContainer');
  if (grid && window.MutationObserver) new MutationObserver(watch).observe(grid, { childList: true, subtree: true });
})();
